export default __webpack_public_path__ + "static/media/icon-arrow-down-white.42e9e7c5.svg";